import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  'room_close_doors': {
    name: (<div className="text"><u>C</u>lose room doors</div>),
    trigger: 'c',
  },
}

/* ****************************************************************************************************************
 * Close all the doors in the current room.
 ******************************************************************************************************************/
Blockly.Blocks['room_close_doors'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Close all the doors in the current room.')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Close all the doors in the current room.')
  }
}

Blockly.JSON['room_close_doors'] = (block) => {
  return {
    action: 'room_close_doors',
  }
}

Schema.registerAction('room_close_doors', {
  "if": {
    "properties": {
      "action": {
        "const": "room_close_doors"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

